import resource from './resource';

import transformToCamelCase from '../shared/transformers/toCamelCaseTransformer';
import transformError from '../shared/transformers/errorTransformer';

function getEmails() {
  return resource
    .get()
    .then(({ body }) => transformToCamelCase(body))
    .then(({ recipients }) => recipients)
    .catch(transformError);
}

function editEmail({ id, ...emailProperties }) {
  return resource
    .update({ emailId: id }, emailProperties)
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

function editEmailStatus({ id, active }) {
  return editEmail({ id, active });
}

function deleteEmail(id) {
  return resource
    .delete({ emailId: id })
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

function addEmail(newMail) {
  return resource
    .save(newMail)
    .then(({ body }) => transformToCamelCase(body))
    .catch(transformError);
}

export default {
  getEmails,
  editEmail,
  editEmailStatus,
  deleteEmail,
  addEmail,
};
